import * as React from "react";

function SvgFreshsales(props, ref) {
  return (
    <svg
      id="Freshsales_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 34.1 34.1"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".Freshsales_svg__st1{fill:#fff}"}</style>
      <path
        d="M17 0h12.8c2.4 0 4.3 1.9 4.3 4.3v12.8c0 9.4-7.6 17-17 17H17c-9.4 0-17-7.6-17-17C-.1 7.7 7.5.1 16.9 0h.1z"
        fill="#ffa800"
      />
      <circle className="Freshsales_svg__st1" cx={17.2} cy={11.9} r={3.4} />
      <path
        className="Freshsales_svg__st1"
        d="M9.7 16.4l5.9 5.9v3.3h2.9v-3.3l5.9-5.9z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgFreshsales);
